import { WZUtils, XUtils } from "./globals";

export const text2time = XUtils.text2time

export function leftSecs(nowTime, endTime) {
  return nowTime > endTime ? 0 : Math.ceil((endTime - nowTime)/ 1000)
}

export function now() {
  return WZUtils.getServerTime()
}

export function pad(n) {
  return n < 10 ? "0" + n : n;
}

export function sec2txt(seconds, mode) {
  var d = 0,
    h = 0,
    m = 0,
    s = 0,
    R = "";
  seconds = seconds > 0 ? seconds : 0;
  s = Math.ceil(seconds);
  if (s >= 60) {
    m = Math.floor(s / 60);
    s = s % 60;
  }
  if (m >= 60) {
    h = Math.floor(m / 60);
    m = m % 60;
  }
  if (h >= 24) {
    d = Math.floor(h / 24);
    h = h % 24;
  }

  if (mode === "zh-cn") {
    if (d > 0) {
      if (d >= 2) {
        R = d * 24 + h + "小时" + pad(m) + "分" + pad(s) + "秒";
      } else {
        R = (h > 0 ? d + 1 : d) + "天";
      }
    } else if (h > 0) {
      R = h + "小时" + pad(m) + "分" + pad(s) + "秒";
    } else if (m > 0) {
      R = m + "分" + pad(s) + "秒";
    } else {
      R = s + "秒";
    }
  } else if (mode === "auto") {
    if (d > 0) {
      R = d + "天";
    } else {
      R = pad(h) + ":" + pad(m) + ":" + pad(s) + "";
    }
  } else {
    if (d > 0) {
      R = d + "天" + pad(h) + ":" + pad(m) + ":" + pad(s) + "";
    } else {
      R = pad(h) + ":" + pad(m) + ":" + pad(s) + "";
    }
  }

  // console.log(R);

  return R;
}
